import React, { FC } from 'react';
import { TableCell, Box, Tooltip, Typography } from '@mui/material';
import { ScheduledStep } from 'models/production-planning';
import { getDetailCellColor, getTooltipContent } from '../utils';

type DetailHourCellProps = {
    cellSteps: ScheduledStep[];
    onCellClick: () => void;
};

const DetailHourCell: FC<DetailHourCellProps> = ({ cellSteps, onCellClick }) => {
    const tooltipText = getTooltipContent(cellSteps);

    return (
        <Tooltip
            title={tooltipText ? <Box sx={{ whiteSpace: 'pre-line', fontSize: '0.75rem' }}>{tooltipText}</Box> : ''}
            arrow
        >
            <TableCell
                align="center"
                sx={{
                    backgroundColor: getDetailCellColor(cellSteps),
                    cursor: cellSteps.length > 0 ? 'pointer' : 'default',
                }}
                onClick={onCellClick}
            >
                {cellSteps.length > 0 && (
                    <Box sx={{}}>
                        <Typography variant="body2" fontWeight={500}>
                            {cellSteps.length}
                        </Typography>
                    </Box>
                )}
            </TableCell>
        </Tooltip>
    );
};

export default DetailHourCell;
